import {Dispatch, FC, SetStateAction, useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {getTask} from '../../../../api/tasks';
import {taskElementStyles} from '../../../../constants/popupStyles';
import {useSnackbarHook} from '../../../../hooks/useSnackbar';
import {Button} from '../../../common/Button';
import Popup from '../../../common/popup/Popup';
import Spinner from '../../../common/Spinner';
import {AlertSettingsProps} from '../../../settings/alert_alarm/types';
import {CurrentTask as CurrentTaskType} from '../../types';
import CurrentTask from '../current_task/CurrentTask';

type TaskRowElementPopupProps = {
    isOpen: boolean,
    taskId: number,
    taskAlertData: Nullable<AlertSettingsProps>,
    setIsOpen: Dispatch<SetStateAction<boolean>>
}

const CompletedTaskPopup: FC<TaskRowElementPopupProps> = ({
  taskId, isOpen, taskAlertData,
  setIsOpen
}) => {
  const {t} = useTranslation('processes');
  const [isLoading, setIsLoading] = useState(false);
  const [taskData, setTaskData] = useState<Nullable<CurrentTaskType>>(null);
  const {addErrorToast} = useSnackbarHook();

  const getTaskData = useCallback(async () => {
    setIsLoading(true);

    try {
      const task = await getTask(Number(taskId));

      setTaskData(task);
    } catch (e) {
      addErrorToast(e?.message);
    } finally {
      setIsLoading(false);
    }
  }, [taskId]);

  const togglePopupVisibility = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  useEffect(() => {
    if (isOpen && !taskData) {
      getTaskData();
    }
  }, [isOpen]);

  return (
    <Popup
      isOpen={isOpen}
      closeModal={togglePopupVisibility}
      popupStyles={taskElementStyles}
    >
      <Spinner isLoading={isLoading}>
        <div className="task-element-popup">
          {taskData &&
              <CurrentTask
                task={taskData}
                taskAlertData={taskAlertData}
                notRunningStatus
                noAnimation
              />
          }
          {!isLoading &&
            <div className="buttons">
              <Button
                label={t('closePopupBtn')}
                className="dark-blue-btn bigger"
                onClick={togglePopupVisibility}
              />
            </div>}
        </div>
      </Spinner>
    </Popup>
  );
};

export default CompletedTaskPopup;
